import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaPlay } from "react-icons/fa";
import { FaPause } from "react-icons/fa6";


const apiUrl = process.env.REACT_APP_API_URL;

const translations = {
  en: {
    header: "How did you lose the money? Explain.",
    description: "Write in detail about how you lost the money.",
    placeholder: "Type your answer here...",
    maxCharacters: "Maximum of 200 Characters",
    ok: "OK",
    errorSelect: "Please select an option before proceeding.",
    alert: "Please answer the current question before proceeding to the next one.",
    invalidChars: "Invalid characters detected. Only letters, numbers, ., _, -, space, (), #, and @ are allowed.",
    limitError: "Please limit your input to 200 characters.",
    errorDsc: "Please enter the description",
  },
  Hi: {
    header: "आपने पैसा कैसे खो दिया? समझाइए।",
    description: "विस्तार से लिखें कि आपने पैसा कैसे खो दिया।",
    placeholder: "यहाँ अपना उत्तर टाइप करें...",
    maxCharacters: "अधिकतम 500 वर्ण",
    ok: "ठीक है",
    errorSelect: "कृपया आगे बढ़ने से पहले एक विकल्प चुनें।",
    alert: "कृपया अगले प्रश्न पर जाने से पहले वर्तमान प्रश्न का उत्तर दें।",
    invalidChars: "अमान्य वर्ण पाए गए। केवल अक्षर, संख्या, ., _, -, space, (), #, और @ की अनुमति है।",
    limitError: "कृपया अपने इनपुट को 500 वर्णों तक सीमित करें।",
    errorDsc: "कृपया विवरण दर्ज करें",
  },
  Kn: {
    header: "ನೀವು ಹೇಗೆ ಹಣವನ್ನು ಕಳೆದುಕೊಂಡಿದ್ದೀರಿ? ವಿವರಿಸಿ.",
    description: "ಹಣವನ್ನು ಹೇಗೆ ಕಳೆದುಕೊಂಡಿದ್ದೀರಿ ಎಂಬುದರ ಬಗ್ಗೆ 200 ಅಕ್ಷರಗಳಿಗೆ ಮೀರದಂತೆ ವಿವರವಾಗಿ ನಮೂದಿಸಿ.",
    placeholder: "ನಿಮ್ಮ ಉತ್ತರವನ್ನು ಇಲ್ಲಿ ಟೈಪ್ ಮಾಡಿ...",
    maxCharacters: "",
    ok: "ಸರಿ",
    errorSelect: "ದಯವಿಟ್ಟು ಮುಂದುವರೆಯುವ ಮೊದಲು ಆಯ್ಕೆಮಾಡಿ.",
    alert: "ದಯವಿಟ್ಟು ಮುಂದಿನ ಪ್ರಶ್ನೆಗೆ ಹೋಗುವ ಮೊದಲು ಪ್ರಸ್ತುತ ಪ್ರಶ್ನೆಗೆ ಉತ್ತರ ನೀಡಿ.",
    invalidChars: "ತಪ್ಪಾದ ಅಕ್ಷರಗಳು ಕಂಡುಬಂದಿವೆ. ಅಕ್ಷರಗಳು, ಸಂಖ್ಯೆಗಳು, ., _, -, ಖಾಲಿ ಜಾಗ, (), #, ಮತ್ತು @ ಮಾತ್ರ ಅನುಮತಿಸಲಾಗಿದೆ.",
    limitError: "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಇನ್ಪುಟ್ ಅನ್ನು 200 ಅಕ್ಷರಗಳವರೆಗೆ ಮಿತಿ ಮಾಡಿ.",
    errorDsc: "ದಯವಿಟ್ಟು ವಿವರಣೆಯನ್ನು ನಮೂದಿಸಿ",
  },
};

const HowLoss=({ onNext, onHowLossSelected, answer, apiKey, botToken, vist_id, app_ver,selectedLang }) =>{
  const [howLoss, setHowLoss] = useState("");
  const [showOkButton, setShowOkButton] = useState(true);
  const [error, setError] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false); // Audio play state
  const audioRef = useRef(null);
  const navigate = useNavigate();

  // Mapping language codes to audio source files
  const audioMap = {
    en: "audio/English BOT Audios/howloss.mp3",
    Hi: "audio/Hindi BOT Audios/Hindi-Audio20.mp3",
    Kn: "audio/Kannada BOT Audios/Kannada-Audio20.m4a",
    tcy: "audio/cybervictim_tcy.mp3",
  };


  // Update audio source when language or playing state changes
  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.src = audioMap[selectedLang] || audioMap["en"];
      audioRef.current.load();
      if (isPlaying) {
        audioRef.current.play();
      }
    }
  }, [selectedLang, isPlaying]);

       useEffect(() => {
           const handler = () => {
            if (audioRef.current) {
               audioRef.current.pause();
               audioRef.current.currentTime = 0;
                setIsPlaying(false);
              }
            };
            window.addEventListener('pauseAllAudio', handler);
            return () => window.removeEventListener('pauseAllAudio', handler);
          }, []);

  // Load stored answer from localStorage if available
  useEffect(() => {
    const storedData = localStorage.getItem("des");
    if (storedData) {
      setHowLoss(JSON.parse(storedData));
      onHowLossSelected(JSON.parse(storedData));
    }
  }, []);

  // Handle key events in the text area: Alt+Enter for newline; Enter for submitting
  const handleKeyDown = (event) => {
    if (event.altKey && event.key === "Enter") {
      event.preventDefault();
      setHowLoss((prevValue) => prevValue + "\n");
    } else if (event.key === "Enter") {
      event.preventDefault();
      handleOkClick(event);
    }
  };

  // Handle change in text area input; enforce valid characters and length limits
  const handleChange = (event) => {
    const { value } = event.target;
    const regex = /^[a-zA-Z0-9., _()&#@-]*$/;
    if (value.length <= 500 && regex.test(value)) {
      setHowLoss(value);
      onHowLossSelected(value);
      setShowOkButton(true);
      setError("");
      localStorage.setItem("des", JSON.stringify(value));
    } else if (value.length > 500) {
      setError('limitError');
    } else {
      setError('invalidChars');
    }
  };

  const handleOkClick = async (e) => {
    e.preventDefault();
    if (audioRef.current && isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    }
    onHowLossSelected(howLoss);
    try {
      const response = await fetch(`${apiUrl}/v1/ccrim_bot_add_submit`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          api_key: apiKey,
          visitor_token: vist_id,
          qtion_id: "66f655a76d2d0",
          qtion_num: "17",
          option_val: howLoss,
          lac_token: botToken,
          app_ver: app_ver,
          bot_lang_id: selectedLang=== "en" ? "2" : selectedLang === "Hi" ? "3" : selectedLang === "Kn" ? "1" : "4",
        }),
      });
      if (!response.ok) {
        throw new Error("Failed to save description");
      }
      const data = await response.json();
      if (data.resp.error_code === "0") {
        sessionStorage.setItem("comp_id", data.resp.complaint_num);
        // Remove a set of keys from localStorage on success
        const keysToRemove = [
          "gender",
          "howMuch",
          "Profession",
          "policeStation",
          "qualification",
          "suspectCall",
          "suspectContact",
          "suspectSpeck",
          "time",
          "victimAge",
          "victimName",
          "zip",
          "file",
          "des",
          "address1",
          "city",
          "formData",
          "district",
          "phoneNumber",
          "formSuspectData",
          "formVictimData",
          "address",
          "policeStations",
          "support",
          "victim",
          "SuspectBank",
          "victimBank",
          "BankFile",
          "bankForms",
          "radio",
          "victimGender",
          "phoneNumbers",
          "nationalId",
          "nationalFile"
        ];
        keysToRemove.forEach((key) => localStorage.removeItem(key));
        sessionStorage.removeItem("access_id");
        // Assuming you want to navigate on success:
        navigate("/success", { replace: true });
        sessionStorage.removeItem("visitor_id");
        sessionStorage.removeItem("otp_id");
        setError("");
      } else {
        setError("errorDsc");
      }
    } catch (error) {
      console.error("Error saving data:", error);
      setError("Failed to save description");
    }
  };

  const toggleAudio = (e) => {
    e.preventDefault();
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
        setIsPlaying(false);
      } else {
        audioRef.current.play();
        setIsPlaying(true);
      }
    }
  };

  const handleAudioEnd = () => {
    setIsPlaying(false);
  };

  return (
    <div className="question" >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <h2 htmlFor="lose-money">
              {translations[selectedLang].header}
              <span style={{ color: "red" }}>*</span>
            </h2>
            <button onClick={toggleAudio} className="audio-button">
              {isPlaying ? <FaPause color="White"size={12} style={{ marginBottom: '20px' }} /> : <FaPlay color="White" size={12} style={{ marginBottom: '20px' }}/>}
            </button>
          </div>
          <audio ref={audioRef} onEnded={handleAudioEnd}>
            <source src={audioMap[selectedLang]} type="audio/mp3" />
            Your browser does not support the audio element.
          </audio>
          <p>{translations[selectedLang].description}</p>
          <textarea
            value={howLoss}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            placeholder={translations[selectedLang].placeholder}
            id="lose-money"
            rows="7"
            cols="80"
            className="responsive-textarea"
            maxLength="500"
          />
          <p style={{ color: "red", marginBottom: "10px" ,fontSize: "14px"}}>
            {translations[selectedLang].maxCharacters}
          </p>
          <div style={{ display: "flex", alignItems: "center", zIndex: "1000" }}>
            {showOkButton && (
              <button type="button" className="ok-btn-text" onClick={handleOkClick}>
                {translations[selectedLang].ok}
              </button>
            )}
            {error && (
              <div className="error-message" style={{ position: "relative", zIndex: "1000" }}>
                {translations[selectedLang][error]}
              </div>
            )}
            {answer[16] && (
              <p className="alert-box">
                {translations[selectedLang].alert}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default HowLoss;
